import { render, staticRenderFns } from "./FuturoLoader.vue?vue&type=template&id=779e641e&scoped=true"
import script from "./FuturoLoader.vue?vue&type=script&lang=js"
export * from "./FuturoLoader.vue?vue&type=script&lang=js"
import style0 from "./FuturoLoader.vue?vue&type=style&index=0&id=779e641e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779e641e",
  null
  
)

export default component.exports